import { bindable, computedFrom } from 'aurelia-framework';
import statuses from 'statuses';

class NewJobModalContainer {
  @bindable open = false;
  @bindable selectedAccount = null;
  @bindable onSave = () => {};
  @bindable onClose = () => {};
  loading = false;
  variants = [];
  operationId = null;
  _variantsAccountId = null;
  /**
   * @param {AppErrorPublisher} appErrorPublisher To publish errors to the UI.
   * @param {errorParser}       errorParser       Used for error parsing.
   * @param {ProductFeedsJobs}  productFeedsJobs  To get the jobs.
   */
  constructor(appErrorPublisher, errorParser, productFeedsJobs) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._newJobModalErrorParser = errorParser.wrap();
    this._productFeedsJobs = productFeedsJobs;
  }
  createJob(variant, mediaNumber) {
    this.loading = true;
    this._productFeedsJobs.createJob(
      this.selectedAccount.id,
      variant,
      mediaNumber,
    )
    .then((job) => {
      this._generateOperationId();
      this.onSave({ job });
      this.onClose();
    })
    .catch((error) => {
      const message = error.status === statuses('conflict') ?
        'There\'s another job running, please wait a few minutes and try again' :
        'There was an error creating the job';
      const parsedError = this._newJobModalErrorParser(error, message);

      this._appErrorPublisher.notify(
        error, parsedError.message,
      );
    })
    .then(() => {
      this.loading = false;
    });
  }
  openChanged(currentStatus, previousStatus) {
    if (!previousStatus && currentStatus) {
      if (this.selectedAccount) {
        this._loadVariants();
      } else {
        this._generateOperationId();
      }
    }
  }
  selectedAccountChanged(currentAccount, previousAccount) {
    if (this.open && (!previousAccount || currentAccount.id !== previousAccount.id)) {
      this._loadVariants();
    }
  }
  @computedFrom('loading')
  get canCloseTheModal() {
    return !this.loading;
  }
  _generateOperationId() {
    this.operationId = (new Date()).getTime();
  }
  _loadVariants() {
    this.loading = true;
    this._productFeedsJobs.getJobVariants(this.selectedAccount.id)
    .then((variants) => {
      this._variantsAccountId = this.selectedAccount.id;
      this.variants = variants;
      this._generateOperationId();
    })
    .catch((error) => {
      const parsedError = this._newJobModalErrorParser(error, 'There was an error loading the variants');

      this._appErrorPublisher.notify(error, parsedError.message);
      this.onClose();
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { NewJobModalContainer };
